import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ISearchResponse } from '@shared/constants/models.const';
import { HelperService } from './helper.service';

@Injectable({
  providedIn: 'root',
})
export class SearchService {

  private readonly http: HttpClient = inject(HttpClient);
  private readonly HELPER: HelperService = inject(HelperService);

  getSearchRequest(options: any): Observable<ISearchResponse> {
    const params = new HttpParams()
      .set('keyword', options['prompt'])
      .set('content-type', this.HELPER.getContentType(options['content-type']))
      .set('skip', options['skip'] || 0)
      .set('take', options['take'] || 10);

    return this.http.get<ISearchResponse>(`:backend-url/content/search/:fr-loc`, { params });
  }
}
